<main class="main">
  <div class="main--container">
    <mat-dialog-content>
      <h2 class="main--title">{{ 'modifyBookVehicle' | i18next }}</h2>
    </mat-dialog-content>
    <form [formGroup]="form">
      <div class="main--infoContainer" *ngIf="!onlyObservations">
        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'forWhom' | i18next }}</mat-label>
          <mat-select formControlName="petitionerType">
            <mat-option [value]="petitionerTypeEnum.SEAT">{{
              'seatEmployee' | i18next
            }}</mat-option>
            <mat-option [value]="petitionerTypeEnum.EXT">{{
              'external' | i18next
            }}</mat-option>
            <mat-option [value]="petitionerTypeEnum.FAM">{{
              'familiar' | i18next
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'phone' | i18next }}</mat-label>
          <input matInput type="text" formControlName="phone" />
        </mat-form-field>
        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'name' | i18next }}</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'firstSurname' | i18next }}</mat-label>
          <input matInput type="text" formControlName="firstSurname" />
        </mat-form-field>
        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'secondSurname' | i18next }}</mat-label>
          <input matInput type="text" formControlName="secondSurname" />
        </mat-form-field>

        <mat-form-field class="main--infoContainer__item">
          <mat-label>{{ 'email' | i18next }}</mat-label>
          <input matInput type="email" formControlName="email" />
        </mat-form-field>
      </div>
      <mat-form-field class="main--comments">
        <mat-label>{{ 'observations' | i18next }}</mat-label>
        <textarea matInput formControlName="observations"></textarea>
      </mat-form-field>
    </form>
    <mat-dialog-actions class="main--dialogBtns">
      <div class="main--dialogBtns__btnContainer">
        <button type="button" class="btn cancel" mat-dialog-close>
          {{ 'altCancel' | i18next | uppercase }}
        </button>
        <button
          type="submit"
          class="btn confirmDark"
          (click)="submitRequest()"
          [disabled]="form.invalid"
        >
          {{ 'stepConfirm' | i18next | uppercase }}
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</main>
